module.exports = __webpack_public_path__ + "static/img/woodland.48a2e2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/woodland.jpg
// module id = GKQY
// module chunks = 0